module.exports = __webpack_public_path__ + "static/media/casegraf-wordmark.a6d52c40.svg";